import { render } from "./TvmColorSwatches.vue?vue&type=template&id=21351a74&scoped=true"
import script from "./TvmColorSwatches.vue?vue&type=script&lang=js"
export * from "./TvmColorSwatches.vue?vue&type=script&lang=js"

import "./TvmColorSwatches.vue?vue&type=style&index=0&id=21351a74&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21351a74"]])

export default __exports__